import { capfirst } from 'journalize';

const getDivisionDisplay = contest =>
  `${capfirst(contest.division_type)} ${(contest.division_type !==
    'statewide' &&
    contest.district) ||
    ''}`.trim();

const getContestDisplay = contest => {
  if (contest.division_type === 'statewide') {
    return contest.office;
  }

  return `${contest.office} ${getDivisionDisplay(contest)}`;
};

const PARTY_SORT_ORDER = [
  'Republican',
  'Democrat',
  'Libertarian',
  'Green',
  'Independent',
  'Write-in',
];

export function sort_candidates_by_party(candidates) {
  return candidates.sort(
    (a, b) =>
      PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
  );
}

const getStatewideDisplay = contest => {
  if (
    contest.office === 'President' ||
    contest.office === 'U.S. Senate' ||
    contest.office === 'Texas Railroad Commission'
  ) {
    return contest.office;
  } else if (
    contest.office === 'Texas Supreme Court' &&
    contest.office_division === 1
  ) {
    return `${contest.office} Chief Justice`;
  } else {
    return `${contest.office} ${contest.division_type} ${contest.office_division}`;
  }
};

const createContestSlug = contest => {
  const parts = [contest.office_slug];

  if (contest.division_type !== 'statewide') {
    parts.push(`-${contest.district}`);
  }

  parts.push(`-${contest.party.slice(0, 3)}`);

  return parts.join('');
};

export function changePartyName(contest) {
  var name = contest == 'Democratic' ? 'Democrat' : 'Republican';
  return name;
}

export {
  createContestSlug,
  getContestDisplay,
  getDivisionDisplay,
  getStatewideDisplay,
};
